<!-- 组件页 -->
<template>
  <div class="icp"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022095797号-4</a></div>
   <div v-if="isUpdate" class="safari_tips">系统正在升级，预计1小时完成，请稍后再来~</div>
  <!-- 组件大图详情 -->
  <div class="widget_large_mask" v-show="showWidget" @click="hideWidget">
    <WidgetPopup
      v-show="showWidget"
      :imageData="currentImageData"
      :similarData="similarWidget"
      @update-is-collected="handleUpdateIsCollected"
      @similarWidget="showImage"
      @hide="hideWidget"
      @editWidget="showEditWidget"
    />
  </div>
  <!-- 编辑组件 -->
  <div class="edit_widget_mask" v-show="isEditWidget">
    <EditWidgetPopup
      :imageDataCode="svgCode"
      :imageData="currentImageData"
      @hideEdit="hideWidget"
    />
  </div>
  <!-- UI大图弹窗 -->
  <div class="widget_large_mask" v-if="showAppImage" @click="hideDetailsImage">
    <IdeaPopup
      :identifier="clickedIdentifier"
      :title="selectedTitle"
      :coverImage="selectedCoverImage"
      :imageUrl="selectedDetailImageUrl"
      :tags="selectedTags"
      :appuiId="selectedAppuiId"
      :similarWidgets="similarWidget"
    />
  </div>

  <!-- 顶部导航栏 -->
  <TopNav
    :key="updateCandy"
    :showLoginPopup="showLoginPopup"
    @close-login="resetLoginPopup"
    ref="childRef"
  />

  <!-- 图片大图 -->
  <div class="widget_large_mask" v-show="showAiPng" @click="hideWidget">
    <AiPngPopup
      v-show="showAiPng"
      :imageData="currentAIPng"
      :similarData="similarAIPng"
      @similarWidget="showAIPng"
      @hide="hideWidget"
    />
  </div>

  <!-- H5搜索结果也搜索框 -->
  <div class="searchresultmain">
    <div class="searchresultbox">
      <img class="search_icon" src="../assets/images/icon_sousuo.svg" />
      <input
        placeholder="输入关键词或组件名称，回车搜索"
        v-model="searchTerm"
        @keydown.enter="handleEnter"
      />
    </div>
  </div>
  <!-- 组件右侧导航和返回顶部 -->
  <div class="widget_right_nav" v-if="!isWidgetTab">
    <div class="widget_nav_item">
      <span><router-link to="/">全部</router-link></span>
      <span
        v-for="item in hotSearch"
        :key="item._id"
        @click="searchByType(item)"
        :class="{ active: selectedItem && selectedItem._id === item._id }"
      >
        {{ item.searchkeyword }}
      </span>
    </div>
    <div class="back_top_btn" v-show="backTop">
      <span @click="scrollToTop">返回顶部</span>
      <img src="../assets/images/backToTopBtn.svg" />
    </div>
  </div>

  <!-- 图库右侧导航 -->
  <div class="widget_right_nav" v-if="$route.path === '/aigc'">
    <div class="widget_nav_item">
      <span
        v-for="(item, index) in pictureType"
        :key="index"
        :class="{ active: selectedType === index }"
        @click="selectItem(index, item.url)">
        {{ item.type }}
      </span>
    </div>
    <div class="back_top_btn" v-show="backTop">
      <span @click="scrollToTop">返回顶部</span>
      <img src="../assets/images/backToTopBtn.svg" />
    </div>
  </div>

  <!-- banner -->
  <div class="home_banner_box">
    <!-- 轮播图 -->
    <div class="home_banner"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave">
      <div class="home_banner_container" :style="carouselStyle">
        <div class="home_banner_item"
          v-for="ad in hoemAd"
          :key="ad._id"
          @click="handleClick(ad.link)">
          <img :src="ad.image" />
        </div>
      </div>
      <!-- 轮播按钮 -->
      <div class="home_banner_dots">
        <span
          v-for="(image, index) in hoemAd"
          :key="index"
          @click="goToSlide(index)"
          :class="{ active: index === currentIndex }"
          class="dot"
        >
        </span>
      </div>
      <img
        class="banner_prevSlide"
        src="../assets/images/icon_banner_dot_btn.svg"
        @click="prevSlide"/>
      <img
        class="banner_nextSlide"
        src="../assets/images/icon_banner_dot_btn.svg"
        @click="nextSlide"/>
    </div>

    <!-- 思维提升 -->
    <div class="home_article">
      <div class="home_article_top">
        <div class="home_article_top_l">
          <img src="../assets/images/icon_read_title.svg" />
          <!-- <span>不啰嗦，不绕圈，浓缩干货</span> -->
        </div>
        <div class="home_article_more"><router-link to="/community">进入社区</router-link></div>
      </div>
      <div class="home_article_list">
        <div
          v-for="item in articleList"
          :key="item._id"
          class="home_article_list_item"
        >
          <div @click="goToArticleDetails(item._id)"
            class="home_article_title">
              <span>{{ item.title }}</span>
              <img v-if="item.newTagByArticle" src="../assets/images/icon_article_new.svg" />
              <img v-if="item.pageView >= 30" src="../assets/images/icon_hot.svg" />
          </div>
        </div>
      </div>
    </div>

    <!-- 用户信息 -->
    <div class="home_userinfo_box">
      <router-link v-if="isLoggedIn()" :to="{ name: 'user', params: { tab: 'me' } }">
        <div class="home_userinfo">
          <img :src="userInfo.imgUrl">
          <span class="user_nickname">{{ userInfo.nickname }}</span>
          <span class="user_about">{{ userInfo.about }}</span>
        </div>
      </router-link>
      <div @click="showLoginbox" v-else class="home_userinfo">
          <img src="../assets/images/img_about_logo.png" />
          <span class="user_nickname">欢迎来到UI大师</span>
          <span class="user_about">登录后体验完整服务</span>
        </div>

        <!-- 已登录 -->
      <div v-if="isLoggedIn()" class="home_user_data">
        <router-link to="/my">
          <div class="home_user_data_item">
            <span class="user_data_number">{{ widgetCountByUser }}</span>
            <span class="user_data_name">发布组件</span>
          </div>
        </router-link>

        <div @click="notifyShowRecordBox" class="home_user_data_item">
          <span class="user_data_number">{{ recordWidget }}</span>
          <span class="user_data_name">今日复制</span>
        </div>

        <div @click="showCopycount" class="home_user_data_item">
          <span class="user_data_number">{{ isCopycount }}</span>
          <span class="user_data_name">被复制</span>
        </div>
      </div>

      <!-- 未登录 -->
      <div v-else class="home_user_data">
        <router-link to="/my">
          <div class="home_user_data_item">
            <span class="user_data_number">0</span>
            <span class="user_data_name">发布组件</span>
          </div>
        </router-link>

        <div @click="notifyShowRecordBox" class="home_user_data_item">
          <span class="user_data_number">0</span>
          <span class="user_data_name">今日复制</span>
        </div>

        <div @click="showCopycount" class="home_user_data_item">
          <span class="user_data_number">0</span>
          <span class="user_data_name">被复制</span>
        </div>
      </div>
    </div>
  </div>

  <!-- 一级分类 -->
  <div id="homeTabPlaceholder"></div>
  <!-- 占位符 -->
  <div class="home_tab_box" id="homeTabBox">
    <div class="home_tab_id">
      <img src="../assets/images/icon_business.svg" />
    </div>
    <nav>
      <router-link to="/my">我的</router-link>
      <router-link to="/" :class="{ active: isWidgetRoute }">组件</router-link>
      <router-link to="/aigc">图库</router-link>
      <router-link to="/thinking">设计思维</router-link>
      <router-link to="/appui">UI/UX</router-link>
    </nav>
  </div>

  <!-- 组件模块 -->
  <div
    class="widget_tab"
    v-if="
      homeTab === '' ||
      [
        '',
        'my',
        'widgets',
        'mobile',
        'pc',
        'element',
        'template',
        'type',
        'tob',
        'graphic',
      ].includes(currentTab)
    "
  >
    <!-- 二级分类筛选导航 -->
    <div class="classify" v-if="!isWidgetTab">
      <div class="classify_box">
        <nav>
          <router-link to="/">最新</router-link>
          <router-link to="/widgets">推荐</router-link>
          <router-link to="/mobile">移动端</router-link>
          <router-link to="/pc">PC端</router-link>
          <router-link to="/element">元素</router-link>
          <router-link to="/template">模板</router-link>
          <router-link to="/tob">B端</router-link>
          <router-link to="/graphic">平面</router-link>
        </nav>
        <div class="tools_link">
          <p>兼容软件/平台：</p>
          <div class="tools_item">
            <a href="https://www.sketch.com/" target="_blank">
              <img title="跳转Sketch" src="../assets/images/icon_sketch.svg" />
            </a>
            <a href="https://www.figma.com/" target="_blank">
              <img title="跳转Figma" src="../assets/images/icon_figma.svg" />
            </a>
            <a href="https://js.design/" target="_blank">
              <img
                title="跳转即时设计"
                src="../assets/images/icon_jsdesign.svg"
              />
            </a>
            <a href="https://mastergo.com/" target="_blank">
              <img
                title="跳转Mastergo"
                src="../assets/images/icon_mastergo.svg"
              />
            </a>
            <a href="https://pixso.cn/" target="_blank">
              <img title="跳转Pixso" src="../assets/images/icon_pixso.svg" />
            </a>
            <a
              href="https://www.adobe.com/cn/creativecloud/roc/business.html"
              target="_blank"
            >
              <img title="跳转XD" src="../assets/images/icon_adobexd.svg" />
            </a>
            <a
              href="https://www.adobe.com/cn/creativecloud/roc/business.html"
              target="_blank"
            >
              <img title="跳转AI" src="../assets/images/icon_adobeai.svg" />
            </a>
          </div>
        </div>
        <!-- 关键词导航---------------------- -->
        <!-- <div class="keyword_nav">
          <span
            v-for="item in hotSearch"
            :key="item._id"
            @click="searchByType(item)"
            :class="{ active: selectedItem && selectedItem._id === item._id }">
            {{ item.searchkeyword }}
          </span>
        </div> -->
      </div>
    </div>

    <!-- 加载中 -->
    <div class="loadingbox" v-show="loading">
      <img src="../assets/images/Loader.gif" />
    </div>

    <!-- 未登录时我的页面 -->
    <div class="logout" v-if="$route.path === '/my' && !isLoggedIn()">
      <img src="../assets/images/icon_logout.svg" />
      <span>登录后可查看已发布的组件</span>
    </div>
    <div
      class="logout"
      v-if="$route.path === '/my' && widget.length === 0 && isLoggedIn()"
    >
      <img src="../assets/images/null.svg" />
      <span>空空如也，快去发布组件吧~</span>
    </div>

    <!-- 组件列表 -->
    <div
      class="widgetlist"
      v-if="
        (!loading && widget.length > 0) ||
        [
          '',
          'my',
          'widgets',
          'mobile',
          'pc',
          'element',
          'template',
          'type',
          'tob',
          'graphic',
        ].includes(currentTab)
      "
      :style="{ width: containerWidth }"
    >
      <!-- 组件item -->
      <div class="list_item" v-for="item in widget" :key="item._id">
        <span class="home_ad_identifier" v-if="item.isAd"
          >由淘宝提供的广告</span
        >
        <!-- 复制后提示 -->
        <div class="widget_tools_link" v-show="item.copySuccess">
          <img src="../assets/images/icon_replicated.svg" />
          <p>组件已复制，请返回设计工具粘贴</p>
          <div class="widget_tools_item">
            <img src="../assets/images/icon_sketch.svg" />
            <img src="../assets/images/icon_figma.svg" />
            <img src="../assets/images/icon_jsdesign.svg" />
            <img src="../assets/images/icon_mastergo.svg" />
            <img src="../assets/images/icon_pixso.svg" />
            <img src="../assets/images/icon_adobexd.svg" />
            <img src="../assets/images/icon_adobeai.svg" />
          </div>
        </div>
        <!-- 鼠标经过显示 -->
        <div
          class="widget_mask"
          v-if="!item.isAd"
          @click="showImage(item._id)"
          @click.stop
        >
          <button
            v-if="
              (!item.author || item.author._id !== userInfo._id) &&
              item.price > 0
            "
            @click="handleCopyCode(item)"
            :disabled="isDisabled"
            :class="{ 'button-disabled': isDisabled }"
            @click.stop
          >
            复制组件 {{ item.price }}🍬
          </button>
          <button
            v-else
            @click="handleCopyCode(item)"
            :disabled="isDisabled"
            :class="{ 'button-disabled': isDisabled }"
            @click.stop
          >
            复制组件
          </button>
          <div class="widget_mask_img">
            <!-- 编辑组件 -->
            <img
              @click="showEditWidget(item._id)"
              src="../assets/images/icon_editwidget.svg"
              @click.stop
            />
            <img
              v-if="item.isCollected"
              src="../assets/images/icon_favorite_hovers.svg"
              @click="toggleCollect(item._id)"
              @click.stop
            />
            <img
              v-else
              src="../assets/images/icon_favorite.svg"
              @click="toggleCollect(item._id)"
              @click.stop
            />
          </div>
          <!-- 提示 -->
          <div v-if="item.isContouring" class="widget_tips">提示：该组件文本已轮廓为形状，不能二次编辑</div>
        </div>
        <div v-else class="widget_ad_mask" @click="openAdLink(item.link)">
          <button @click="copyMarketAdCode(item.code)" @click.stop>
            复制淘口令
          </button>
        </div>
        <div class="marketad_price" v-if="item.isAd">
          到手价{{ item.price }}元
        </div>
        <img
          v-lazy="item.image"
          @load="handleImageLoad"
          @click="item.isAd ? openAdLink(item.link) : showImage(item._id)"
        />
        <!-- 标题、标签、作者 -->
        <div class="widget_title">
          <router-link
            v-if="!item.isAd"
            :to="{ name: 'widgetdetails', params: { id: item._id } }"
            target="_blank"
          >
            <h1 title="组件详情">{{ item.title }}</h1>
          </router-link>

          <!-- 如果是广告，不跳转，只显示内容 -->
          <h1 v-else @click="openAdLink(item.link)">{{ item.title }}</h1>

          <div class="list_tags" @click.stop>
            <div
              class="list_tags_item"
              @click="searchByKeyword(tag)"
              v-for="tag in item.tags"
              :key="tag"
            >
              <span v-if="tag">#{{ tag }}</span>
            </div>
          </div>
          <!-- 作者和价格 -->
          <div class="widget_author_box" v-if="!item.isAd">
            <div v-if="item.author" class="widget_author">
              <router-link
                :to="{ name: 'userspace', params: { id: item.author._id } }"
                target="_blank"
              >
                <div class="widget_author_avatar">
                  <img :src="item.author.imgUrl" />
                </div>
                <span>{{ item.author.nickname }}</span>
              </router-link>
            </div>
            <div v-else class="widget_author_system">
              <div class="widget_popup_avatar">
                <div class="widget_author_avatar">
                  <img src="../assets/images/img_about_logo.png" />
                </div>
              </div>
              <span>UI大师官方</span>
            </div>
            <div v-if="item.price > 0" class="widget_price">
              {{ item.price }}
              <img src="../assets/images/icon_candy.svg" />
            </div>
            <div v-else class="widget_price_free">免费</div>
          </div>
        </div>

      </div>
    </div>
    <!-- 分页 -->
    <div class="paginationbox" v-if="showPaginationBox">
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :hide-on-single-page="true"
        :total="totalCount"
        :page-count="totalPages"
        :pager-count="5"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- <div class="buttom_tips" v-show="showBottomTips">已经到底了！</div> -->
  </div>

  <!-- 图库 -->
  <div class="widget_tab" v-if="homeTab === 'aigc'">
    <div class="widgetlist" :style="{ width: containerWidth }">
      <div class="list_item_ai" v-for="item in pngList" :key="item._id">
        <!-- 广告 -->
        <span class="home_ad_identifier" v-if="item.isAd"
          >由淘宝提供的广告</span
        >
        <div class="marketad_price" v-if="item.isAd">
          到手价{{ item.price }}元
        </div>
        <div
          v-if="item.isAd"
          class="widget_ad_mask"
          @click="openAdLink(item.link)"
        >
          <button @click="copyMarketAdCode(item.code)" @click.stop>
            复制淘口令
          </button>
        </div>

        <!-- 封面 -->
        <div v-if="item.price === 0" class="picture_price">免费</div>
        <img
          v-lazy="item.isAd ? item.image : item.cover"
          @load="handleImageLoad"
          @click="item.isAd ? openAdLink(item.link) : showAIPng(item._id)"
        />
      </div>
    </div>
    <!-- 分页 -->
    <div class="paginationbox" v-if="showPaginationBox">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPageToPng"
        :hide-on-single-page="true"
        :total="totalCountToPng"
        :page-count="totalPagesToPng"
        :pager-count="5"
        @current-change="handleChangeToAI"
      />
    </div>
  </div>

  <!-- 设计思维 -->
  <div class="applist" v-if="homeTab === 'thinking'">
    <div class="ui_list">
      <div
        @click="
          showDetailsImage(
            'div',
            item.title,
            item.coverImage,
            item.url,
            item.tags,
            item.detailImageId
          )
        "
        class="ui_list_items"
        v-for="item in readUI"
        :key="item._id"
      >
        <div class="ui_item_mask">
          <div class="ui_item_content">
            <span>功能分析</span>
            <pre>{{ item.outline }}</pre>
          </div>
        </div>
        <img :src="item.url" />
      </div>
    </div>
    <!-- 分页 -->
    <div class="app_pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="uiPage"
        :hide-on-single-page="true"
        :total="totalPagesToPng"
        :page-count="uiTotalPages"
        :pager-count="5"
        @current-change="handleChangeUI"
      />
    </div>
  </div>

  <!-- UI -->
  <div class="applist" v-if="homeTab === 'appui'">
    <div class="ui_list">
      <div class="ui_list_item" v-for="item in allAppImages" :key="item._id">
        <img
          v-lazy="item.url"
          @click="
            showDetailsImage(
              'img',
              item.title,
              item.coverImage,
              item.url,
              item.tags,
              item.detailImageId
            )
          "
        />

        <router-link
          :to="{ name: 'appdetails', params: { id: item._id } }"
          target="_blank"
        >
          <div class="list_item_logo" v-show="item.matchingTagsCount > 0">
            <img :src="item.coverImage" />
            <div class="list_item_logo_right">
              <b>{{ item.matchingTagsCount }}</b> 个组件
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 分页 -->
    <div class="app_pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPageScreen"
        :hide-on-single-page="true"
        :total="totalCountScreen"
        :page-count="totalPagesScreen"
        :pager-count="5"
        @current-change="handleCurrentChangeScreen"
      />
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  watch,
  onBeforeUnmount,
  watchEffect,
  provide,
  nextTick,
  onUnmounted,
  computed
} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { get, post, del } from '../utils/request'
import TopNav from '../components/TopNav.vue'
import WidgetPopup from '../components/WidgetPopup.vue'
import EditWidgetPopup from '../components/widget/EditWidgetPopup.vue'
import { ElMessage } from 'element-plus'
import { useUserEffect } from '@/store/modules/useUserEffect'
import { fetchTotalCount } from '../utils/utils'
import { useStore } from 'vuex'
import IdeaPopup from '../components/idea/IdeaPopup.vue'
import AiPngPopup from '@/components/widget/AiPngPopup.vue'
import DOMPurify from 'dompurify'
const moment = require('moment-timezone')

const store = useStore()
const { userInfo, getUserInfo } = useUserEffect()
const widget = ref([]) // 列表数据
const similarWidget = ref([]) // 相似组件数据
const totalCount = ref(0) // 总数
const currentPage = ref(1) // 当前页数
const totalPages = ref(0) // 总数
const searchTerm = ref('') // 使用 ref() 创建响应式变量
// const instance = getCurrentInstance() // 获取路由路径
const showWidget = ref(false) // 组件弹窗
const isEditWidget = ref(false) // 编辑组件弹窗
const homeTab = ref('') // 一级分类标签
const currentTab = ref('') // 二级分类标签
const currentImageData = ref(null) // 弹窗大图
const updateCandy = ref(0) // 加载顶部U糖初始值
const loading = ref(true) // 加载状态
const isCollected = ref(false) // 收藏状态
provide('isCollected', isCollected) // 共享收藏状态给子组件
const array = ref([]) // 定义空数组存储元素高度
const columns = ref(5) // 默认列数
const containerWidth = ref('') // 浏览器宽度
const isWidgetMask = ref(true) // 加载遮罩
const route = useRoute()
const showBottomTips = ref(route.path === '/')
const showPaginationBox = ref(false) // 分页显示
const hotSearch = ref([]) // 热搜词
const selectedItem = ref(null) // 关键词导航选中的项
const showScrollButton = ref(false) // 返回顶部按钮
const currentIndex = ref(0) // 当前图片索引
const slideInterval = ref(null) // 自动切换轮播
const isHovered = ref(false) // 是否自动轮播
const hoemAd = ref([]) // 首页广告
const widgetRoutes = [
  '/',
  '/widgets',
  '/mobile',
  '/pc',
  '/element',
  '/template',
  '/type',
  '/tob',
  '/graphic'
] // 定义需要匹配的路径
const isWidgetTab = ref(false) // 二级分类显示和隐藏
const allAppImages = ref([]) // UI/UX图片
const totalCountScreen = ref(0) // 总数
const currentPageScreen = ref(1) // 当前页数
const totalPagesScreen = ref(0) // 总数
const readUI = ref([]) // 设计思维
const uiPage = ref(1) // 当前页数
const uiTotal = ref(0) // 总数
const uiTotalPages = ref(0) // 总页数
const showAppImage = ref(false) // 大图弹窗
provide('showAppImage', showAppImage) // 共享状态给子组件
const selectedDetailImageUrl = ref(null) // 详情图
const selectedTitle = ref('') // 标题
const selectedCoverImage = ref('') // 封面
const selectedTags = ref([]) // 标签
const clickedIdentifier = ref('') // 区分弹窗内容
const selectedAppuiId = ref('') // 功能分析
const backTop = ref(false)
const svgCode = ref('') // 请求到的svg代码
const isDisabled = ref(false) // 允许点击状态
const showLoginPopup = ref(false) // 通知子组件登录弹窗标识
const pngList = ref([]) // 图库列表
const totalCountToPng = ref(0) // 总数
const currentPageToPng = ref(1) // 当前页数
const totalPagesToPng = ref(0) // 总数
const showAiPng = ref(false) // 图片弹窗
const currentAIPng = ref(null) // AI图库弹窗大图
const similarAIPng = ref([]) // 相似AI图片

// 切换二级分类时选中【组件】
const isWidgetRoute = computed(() => {
  return widgetRoutes.includes(route.path)
})

// 首页广告
const getHomeAd = async () => {
  const cacheKey = 'homeAdData'
  const cacheExpirationKey = 'homeAdCacheExpiration'

  // 设定缓存过期时间
  const cacheDuration = 1 * 60 * 60 * 1000

  // 获取本地缓存的数据和过期时间
  const cachedData = localStorage.getItem(cacheKey)
  const cacheExpiration = localStorage.getItem(cacheExpirationKey)
  const now = Date.now()

  // 如果有缓存，并且缓存未过期，则优先使用缓存
  if (cachedData && cacheExpiration && now < cacheExpiration) {
    hoemAd.value = JSON.parse(cachedData)
  } else {
    // 如果没有缓存或缓存已过期，发送请求获取数据
    const result = await get('/api/homead/banner')

    if (result?.errno === 0 && result?.data?.length) {
      hoemAd.value = result.data

      // 将数据存入本地缓存
      localStorage.setItem(cacheKey, JSON.stringify(result.data))

      // 设置新的缓存过期时间
      localStorage.setItem(cacheExpirationKey, now + cacheDuration)
    }
  }
}

// 【banner】跳转到对应的图片
const goToSlide = (index) => {
  currentIndex.value = index
}

// 【banner】自动轮播
const prevSlide = () => {
  currentIndex.value =
    (currentIndex.value - 1 + hoemAd.value.length) % hoemAd.value.length
}
const nextSlide = () => {
  currentIndex.value = (currentIndex.value + 1) % hoemAd.value.length
}
const startAutoSlide = () => {
  slideInterval.value = setInterval(nextSlide, 3000)
}
const stopAutoSlide = () => {
  clearInterval(slideInterval.value)
}

// 监听移动端滑动轮播图
let startX = 0
let endX = 0
const handleTouchStart = (event) => {
  startX = event.touches[0].clientX
}
const handleTouchMove = (event) => {
  endX = event.touches[0].clientX
}
const handleTouchEnd = () => {
  const deltaX = endX - startX
  if (Math.abs(deltaX) > 50) {
    // 如果滑动距离大于50px
    if (deltaX > 0) {
      prevSlide() // 向右滑动，上一张
    } else {
      nextSlide() // 向左滑动，下一张
    }
  }
}

// 【banner】轮播图点击跳转逻辑
const handleClick = (link) => {
  window.open(link, '_blank') // 在新窗口中打开对应的链接
}

// 【banner】样式计算，根据当前图片的索引来移动
const carouselStyle = computed(() => {
  return {
    transform: `translateX(-${currentIndex.value * 100}%)`,
    transition: 'transform 0.5s ease'
  }
})

// 【banner】当鼠标悬停时停止自动轮播
const handleMouseEnter = () => {
  isHovered.value = true
  stopAutoSlide()
}

// 【banner】当鼠标移开时恢复自动轮播
const handleMouseLeave = () => {
  isHovered.value = false
  startAutoSlide()
}

// h5的搜索组件
const search = (term) => {
  // 导航到搜索结果页面，并传递搜索关键词作为参数
  router.push({ name: 'search', query: { type: 'widget', q: term } })
  searchTerm.value = term
}
// h5的回车搜索
const handleEnter = (event) => {
  if (event.key === 'Enter') {
    search(searchTerm.value) // 调用搜索方法
  }
}

// 点击标签搜索
const searchByKeyword = (keyword) => {
  router.push({ name: 'search', query: { type: 'widget', q: keyword } })
}

// 点击关键词导航搜索
const searchByType = async (item) => {
  selectedItem.value = item // 设置选中的项
  router.push('/type')
  try {
    loading.value = true
    showPaginationBox.value = false
    const response = await get(`/api/widget/search/${item.searchkeyword}`)
    if (response?.errno === 0 && Array.isArray(response.data)) {
      // 获取用户已收藏的组件ID列表
      let userFavorites = []
      if (isLoggedIn()) {
        userFavorites = await getUserFavorites()
      }
      // 提取收藏的组件ID
      const collectedIds = Array.isArray(userFavorites)
        ? userFavorites.map((item) => item.widgetId._id.toString())
        : []
      widget.value = response.data || []
      waitForImagesToLoad()
      // 更新布局
      nextTick(() => {
        getWaterfall()
      })
      // 在组件列表中标记已收藏的组件
      widget.value.forEach((item) => {
        if (isLoggedIn()) {
          item.isCollected = collectedIds.some(
            (collectedId) => collectedId === item._id.toString()
          )
        } else {
          item.isCollected = false // 未登录时，所有组件都是未收藏状态
        }
      })
    }
  } catch (error) {
    console.error('搜索请求失败:', error)
  } finally {
    loading.value = false // 无论请求成功还是失败，都将 loading 设置为 false
    isWidgetMask.value = false
  }
}

// 滚动到页面顶部
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 平滑滚动至顶部
  })
}

// 登录状态
const isLoggedIn = () => {
  return localStorage.getItem('isLogin') === 'true'
}

// 窗口宽度
const handleResize = () => {
  updateColumns()
  nextTick(() => {
    waitForImagesToLoad()
    getWaterfall()
    getWaterfallByPicture()
  })
}

// 滚动屏幕显示和隐藏导航
const handleScroll = () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  // 滚动到底部显示页码
  const clientHeight = document.documentElement.clientHeight
  const scrollHeight = document.documentElement.scrollHeight
  const isBottom = scrollTop + clientHeight >= scrollHeight
  if (route.path === '/type') {
    showPaginationBox.value = false
  } else {
    showPaginationBox.value = isBottom
  }
}

const handleScrollToTop = () => {
  const scrollPosition = window.innerHeight + window.scrollY
  const documentHeight = document.documentElement.scrollHeight

  // 判断是否距离页面底部
  showScrollButton.value = documentHeight - scrollPosition <= 200
}

// 页面初始化时发送请求获取数据------------------------------------------------------
onMounted(async () => {
  await getUserInfo()
  getWidget()
  updateColumns()
  waitForImagesToLoad() // 图片加载函数
  getHotSearch() // 关键词导航
  startAutoSlide() // 启动自动轮播
  getHomeAd() // 获取首页广告
  getArticle() // 获取文章
  init() // 监听页面加载完成
  getRecordWidget() // 获取今日复制
  getWidgetByUser() // 获取已发布的组件数量
  getCopyCountByUser() // 获取被复制的次数
  // 更新布局，确保 DOM 完全渲染
  nextTick(() => {
    getWaterfall()
    getWaterfallByPicture()
    loading.value = false
  })
  window.addEventListener('resize', handleResize) // 监听窗口
  // 监听屏幕滚动隐藏/显示关键词导航
  window.addEventListener('scroll', handleScroll) // 导航栏
  window.addEventListener('scroll', handleScrollToTop) // 返回顶部按钮
  window.addEventListener('scroll', handleScrollTab) // 悬浮一级导航

  // 监听移动端滑动轮播图
  const slideElement = document.querySelector('.home_banner')
  slideElement.addEventListener('touchstart', handleTouchStart)
  slideElement.addEventListener('touchmove', handleTouchMove)
  slideElement.addEventListener('touchend', handleTouchEnd)

  // 监听 userInfo._id 的变化在执行fetchTotalCount
  watchEffect(() => {
    const userId = userInfo._id
    if (userId) {
      fetchTotalCount(userInfo._id, store)
    }
  })

  // 如果在右侧菜单刷新，重定向到首页
  if (route.path === '/type') {
    router.push('/')
  }
})

// 监听屏幕滚动，移除监听器，在组件被完全销毁之后触发
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll) // 导航栏
  window.removeEventListener('scroll', handleScrollTab) // 悬浮一级导航
  stopAutoSlide() // 清除定时器
})

// 在组件即将被销毁之前触发
onBeforeUnmount(() => {
  // 监听移动端滑动轮播图
  const slideElement = document.querySelector('.home_banner')
  slideElement.removeEventListener('touchstart', handleTouchStart)
  slideElement.removeEventListener('touchmove', handleTouchMove)
  slideElement.removeEventListener('touchend', handleTouchEnd)
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('scroll', handleScrollToTop) // 返回顶部按钮
})

// 监听屏幕滚动，悬浮一级导航
const handleScrollTab = () => {
  const homeTabBox = document.getElementById('homeTabBox')
  const placeholder = document.getElementById('homeTabPlaceholder')

  if (!homeTabBox || !placeholder) {
    return
  }
  if (window.scrollY > 220) {
    // 当滚动超过像素时，设置占位符高度与 homeTabBox 的高度一致
    placeholder.style.height = `${homeTabBox.offsetHeight + 20}px`
    placeholder.style.visibility = 'visible' // 显示占位符
    homeTabBox.classList.add('home_tab_box_fixed')
    backTop.value = true // 显示返回顶部按钮
  } else {
    // 滚动回到 100 像素以内时，移除 fixed 类并隐藏占位符
    placeholder.style.height = '0'
    placeholder.style.visibility = 'hidden'
    homeTabBox.classList.remove('home_tab_box_fixed')
    backTop.value = false
  }
}

// 查询已收藏
const getUserFavorites = async () => {
  await getUserInfo()
  try {
    if (!isLoggedIn()) {
      return [] // 如果未登录，则直接返回空数组或其他默认值
    }
    const userId = userInfo._id
    const result = await get(`/api/collect/${userId}`)
    if (result?.errno === 0 && result?.data) {
      return result.data.widgets // 返回已收藏组件的数组
    }
  } catch (error) {
    console.error('查询收藏失败:', error.message)
    throw error
  }
}

// 获取关键词导航
const getHotSearch = async () => {
  const result = await get('/api/hotsearch')
  if (result?.errno === 0 && result?.data?.length) {
    hotSearch.value = result.data
  }
}

// 根据不同路由请求不同接口------------------------------------------------------
const isUpdate = ref(false) // 是否更新
const getWidget = async (page = 1) => {
  let url = '/api/widget' // 默认请求的接口地址
  if (route.path === '/widgets') {
    url = '/api/widget/top'
  } else if (route.path === '/mobile') {
    url = 'api/widget/tab/mobile'
  } else if (route.path === '/pc') {
    url = '/api/widget/tab/pc'
  } else if (route.path === '/element') {
    url = '/api/widget/tab/element'
  } else if (route.path === '/template') {
    url = '/api/widget/tab/template'
  } else if (route.path === '/tob') {
    url = '/api/widget/tab/tob'
  } else if (route.path === '/graphic') {
    url = '/api/widget/tab/graphic'
  } else if (route.path === '/my') {
    // 未登录时切换我的不发送请求
    if (route.path === '/my' && !isLoggedIn()) {
      return
    }
    url = `/api/widget/me/${userInfo._id}`
  }
  loading.value = true
  try {
    const result = await get(url, { page })
    if (result?.errno === 0) {
      // 获取用户已收藏的组件ID列表
      let userFavorites = []
      if (isLoggedIn()) {
        userFavorites = await getUserFavorites()
      }
      // 提取收藏的组件ID
      const collectedIds = Array.isArray(userFavorites)
        ? userFavorites.map((item) => item.widgetId._id.toString())
        : []
      // 初始化 widget 数据并为每个 item 添加 copySuccess 属性
      widget.value = (result.data.list || result.data || []).map((item) => ({
        ...item,
        copySuccess: false // 添加 copySuccess 属性，默认值为 false
      }))
      // 获取广告
      // await getRandomMarketAd()
      // // 将广告随机插入到 widget 列表中
      // if (randomMarketAd.value) {
      //   const insertIndex = 3 // 第4条位置
      //   // const randomIndex = Math.floor(Math.random() * widget.value.length) //随机位置
      //   widget.value.splice(insertIndex, 0, randomMarketAd.value)
      // }

      // 查询列表数据后更新布局
      waitForImagesToLoad()
      nextTick(() => {
        getWaterfall()
      })
      totalCount.value = result.data.totalCount || 0
      currentPage.value = page
      totalPages.value = result.data.totalPages || 0 // 获取总页数
      // 在组件列表中标记已收藏的组件
      widget.value.forEach((item) => {
        if (isLoggedIn()) {
          item.isCollected = collectedIds.some(
            (collectedId) => collectedId === item._id.toString()
          )
        } else {
          item.isCollected = false // 未登录时，所有组件都是未收藏状态
        }
      })
    }
  } catch (error) {
    isUpdate.value = true // 显示更新信息
    console.error(error)
  } finally {
    loading.value = false // 无论请求成功还是失败，都将 loading 设置为 false
  }
}
// 在切换标签重新发送请求并更新数据，路由为category不执行
watch(
  () => route.fullPath,
  (newPath) => {
    if (newPath !== '/type') {
      getWidget()
      selectedItem.value = null // 移除选中的项
    }
  },
  { immediate: true }
)

// 切换页码
const handleCurrentChange = (page) => {
  getWidget(page)
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 平滑滚动效果
  })
}

// 显示组件弹窗
const showImage = async (id) => {
  if (isLoggedIn()) {
    const userId = userInfo._id
    isCollected.value = await checkIfCollected(userId, id)
  }
  try {
    const result = await get(`/api/widget/${id}`)
    if (result?.errno === 0 && result?.data) {
      currentImageData.value = result.data // 更新当前图片数据
      // 更新浏览器地址栏中的 URL
      const newUrl = `/ui/${id}`
      window.history.pushState({}, '', newUrl)
      enterWidgetPopup() // 显示图片弹窗
      getWidgetByTags(id) // 按标签查询相似组件
    } else {
      console.error('获取失败:', result?.errmsg || '未知错误')
    }
  } catch (error) {
    console.error('获取失败:', error.message)
  }
}

// 显示编辑组件弹窗
const showEditWidget = async (id) => {
  // 验证是否登录
  const isLoggedIn = localStorage.getItem('isLogin') === 'true'
  if (!isLoggedIn) {
    ElMessage.warning('请先登录！')
    showLoginPopup.value = false
    await nextTick() // 等待 DOM 更新后再将 showLoginPopup 设置为 true
    showLoginPopup.value = true
    return
  }

  try {
    const result = await get(`/api/widget/${id}`)
    if (result?.errno === 0 && result?.data) {
      currentImageData.value = result.data // 更新当前图片数据
      getCode(id)
      enterEditWidgetPopup() // 显示图片弹窗
    } else {
      console.error('获取失败:', result?.errmsg || '未知错误')
    }
  } catch (error) {
    console.error('获取失败:', error.message)
  }
}

// 请求svg代码
const getCode = async (id) => {
  try {
    const result = await get(`/api/widget/code/${id}`)
    if (result?.errno === 0) {
      svgCode.value = result.data.code // 先将获取的数据存储到 code
    }
  } catch (error) {
    ElMessage.error('获取失败')
  }
}

// 隐藏弹窗
const hideWidget = () => {
  const currentTab = router.currentRoute.value.params.tab // 获取当前的动态 tab 参数
  const url = router.resolve({
    name: 'widget',
    params: { tab: currentTab }
  }).href
  window.history.replaceState(null, '', url) // 更新 URL 而不进行实际的导航
  showWidget.value = false
  isEditWidget.value = false
  showAiPng.value = false
  document.body.style.overflow = 'auto' // 恢复滚动
  getRecordWidget() // 获取今日复制
  getCopyCountByUser() // 获取被复制的总数
  reloadCandy() // 重新加载顶部U糖数据
  // 手动调用子组件的 hideSelf 方法
  const widgetPopupRef = ref(null)
  if (widgetPopupRef.value) {
    widgetPopupRef.value.hideSelf() // 使用 expose 公开方法
  }
}

// 显示弹窗
const enterWidgetPopup = () => {
  showWidget.value = true
  if (showWidget.value) {
    document.body.style.overflow = 'hidden'
  } else {
    // 隐藏子组件后恢复滚动
    document.body.style.overflow = 'auto'
  }
}

// 显示编辑弹窗
const enterEditWidgetPopup = () => {
  isEditWidget.value = true
  showWidget.value = false // 隐藏组件弹窗
  if (isEditWidget.value) {
    document.body.style.overflow = 'hidden'
  } else {
    // 隐藏子组件后恢复滚动
    document.body.style.overflow = 'auto'
  }
}

// 按标签查询相似组件
const getWidgetByTags = async (id) => {
  const tags = currentImageData.value.tags
  const response = await post('/api/widget/search/tags', { tags, id })
  if (response?.errno === 0 && response?.data) {
    similarWidget.value = response.data
  }
}

// UI页面按标签查询相似组件
const getWidgetByUITags = async (tags) => {
  const response = await post('/api/widget/search/uiTags', { tags })
  if (response?.errno === 0 && response?.data) {
    similarWidget.value = response.data
  }
}

// 组件弹窗点击后回传组件ID和收藏状态
const handleUpdateIsCollected = (itemId, newValue) => {
  widget.value.forEach((item) => {
    if (item._id === itemId) {
      item.isCollected = newValue
    }
  })
}

// 收藏和取消组件
const toggleCollect = async (itemId) => {
  // 验证是否登录
  const isLoggedIn = localStorage.getItem('isLogin') === 'true'
  if (!isLoggedIn) {
    ElMessage.warning('请先登录！')
    showLoginPopup.value = false
    await nextTick() // 等待 DOM 更新后再将 showLoginPopup 设置为 true
    showLoginPopup.value = true
    return
  }
  // 根据判断再发送请求
  const userId = userInfo._id
  isCollected.value = await checkIfCollected(userId, itemId)
  let result
  if (isCollected.value) {
    widget.value.forEach((item) => {
      if (item._id === itemId) {
        item.isCollected = false
      }
    })
    result = await removeCollect(userId, itemId)
    fetchTotalCount(userInfo._id, store)
    ElMessage.success('已取消收藏！')
  } else {
    result = await post('/api/collect', { userId, widgetId: itemId })
    fetchTotalCount(userInfo._id, store)
    ElMessage.success('收藏成功！')
  }
  if (result?.errno === 0) {
    // 更新 widget.value 数组中对应项的 isCollected 属性
    widget.value.forEach((item) => {
      if (item._id === itemId) {
        item.isCollected = !isCollected.value
      }
    })
  }
}

// 取消收藏组件方法
const removeCollect = async (userId, itemId) => {
  try {
    const response = await del(`/api/collect/${userId}/${itemId}`)
    if (response.data.errno === 0) {
      return response.data // 返回成功的响应数据
    }
  } catch (error) {
    console.error('取消收藏失败:', error)
    throw error
  }
}

// 检查当前数据是否已收藏
const checkIfCollected = async (userId, itemId) => {
  try {
    const response = await get(`/api/collect/check/${userId}/${itemId}`)
    if (response?.errno === 0 && response?.data) {
      return true
    }
  } catch (error) {
    console.error('检查是否收藏失败:', error.message)
  }
  return false
}

// 更新当前标签
// 二级分类
const updateCurrentTab = (tab) => {
  currentTab.value = tab || ''
}
// 一级分类
const updateHomeTab = (tab) => {
  homeTab.value = tab || ''
}

// 初始化
const init = () => {
  updateCurrentTab(router.currentRoute.value.params.tab) // 二级分类
  updateHomeTab(router.currentRoute.value.params.tab) // 一级分类
}

// 监听路由的变化
const router = useRouter()
router.afterEach(() => {
  init()
})

// 解绑监听器
onBeforeUnmount(() => {
  router.afterEach(null)
})

// 重新加载顶部U糖数据
const reloadCandy = () => {
  updateCandy.value = Math.floor(Math.random() * 100) // 随机数变化更新组件
}

// 记录U糖变化
const createCandyLogBase = async ({
  userId,
  widgetId,
  type,
  copyType,
  candys
}) => {
  const currentDate = new Date() // 获取中国北京时间（UTC+8）
  const offset = 8 * 60 // UTC+8 的分钟数
  const addTime = new Date(currentDate.getTime() + offset * 60 * 1000)
    .toISOString()
    .replace('Z', '+08:00')
  try {
    const formData = new FormData()
    formData.append('userId', userId)
    formData.append('widgetId', widgetId)
    formData.append('type', type)
    formData.append('copyType', copyType)
    formData.append('candys', candys)
    formData.append('addTime', addTime)
    const result = await post('/api/candyLog', formData)
    if (result?.errno === 0) {
      return
    }
  } catch (e) {
    console.error(e)
  }
}
// 记录用户U糖变化
const createCandyLog = async (item) => {
  const userId = userInfo._id
  const widgetId = item._id
  const type = '复制组件'
  const copyType = false
  const candys = item.price
  await createCandyLogBase({ userId, widgetId, type, copyType, candys })
}
// 生成免费复制记录
const createFreeCandyLog = async (imageData) => {
  const userId = userInfo._id
  const widgetId = imageData._id
  const type = '复制组件'
  const copyType = false
  const candys = 0
  await createCandyLogBase({ userId, widgetId, type, copyType, candys })
}
// 记录作者U糖变化
const createCandyLogInauthor = async (item) => {
  const authorId = item.author?._id
  const widgetId = item._id
  const type = '组件被复制'
  const copyType = true
  const candys = item.price
  await createCandyLogBase({
    userId: authorId,
    widgetId,
    type,
    copyType,
    candys
  })
}

// 更新作者U糖
const upCandyInauthor = async (item) => {
  try {
    const authorId = item.author?._id
    const candyResult = await post(`/api/user/add-candys/${authorId}`, {
      candys: item.price
    })
    if (candyResult?.errno === 0) {
      return
    }
  } catch (e) {
    console.error(e)
  }
}

// 限制频繁复制
const handleCopyCode = async (item) => {
  if (isDisabled.value) return

  isDisabled.value = true
  await copyCode(item) // 执行相关逻辑

  // *秒后重新允许点击
  setTimeout(() => {
    isDisabled.value = false
  }, 2000)
}

// 复制组件逻辑
const copyCode = async (item) => {
  const userId = userInfo._id
  const authorId = item.author?._id // 使用可选链操作符检查 author 是否存在

  // 复制代码到剪贴板的通用函数
  const copyToClipboard = (code) => {
    const textarea = document.createElement('textarea')
    textarea.value = code
    textarea.style.position = 'fixed' // 避免在页面上滚动
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
  }

  //  监测是否为Safari浏览器
  function isSafari () {
    const ua = navigator.userAgent.toLowerCase()
    return ua.includes('safari') && !ua.includes('chrome')
  }
  // 检测是否是 Safari 浏览器
  if (isSafari()) {
    ElMessage.error('当前浏览器暂不支持复制组件！')
    return
  }

  // 验证是否登录
  const isLoggedIn = localStorage.getItem('isLogin') === 'true'
  if (!isLoggedIn) {
    ElMessage.warning('请先登录！每天登录可获得10U糖')
    showLoginPopup.value = false
    await nextTick() // 等待 DOM 更新后再将 showLoginPopup 设置为 true
    showLoginPopup.value = true
    return
  }

  // 复制后提示
  item.copySuccess = true
  // 自动将 copySuccess 设置为 false
  setTimeout(() => {
    item.copySuccess = false
  }, 2000)

  try {
    // 如果用户是作者，直接复制代码
    if (userId === authorId || item.price === 0) {
      const result = await get(`/api/widget/code/${item._id}`)
      if (result?.errno === 0) {
        ElMessage.success('组件已复制，请返回设计工具粘贴！')
        copyToClipboard(result.data.code)
        await createFreeCandyLog(item) // 生成免费记录
        getRecordWidget() // 获取今日复制
        getCopyCountByUser() // 获取被复制的总数
      } else {
        ElMessage.error('复制失败!')
      }
    } else {
      // 如果没有作者信息或作者不是当前用户，判断U糖数量
      if (userInfo.candys < item.price) {
        ElMessage.error('U糖不足！每天登录可获得10U糖')
        return
      }
      // 扣除用户U糖
      const candyResult = await post(`/api/user/candys/${userId}`, {
        candys: item.price
      })
      if (candyResult?.errno === 0) {
        await createCandyLogInauthor(item) // 生成作者记录
        await createCandyLog(item) // 生成用户记录
        await upCandyInauthor(item) // 更新U糖
        reloadCandy() // 重新加载顶部U糖数据
        getRecordWidget() // 获取今日复制
        getCopyCountByUser() // 获取被复制的总数
      } else {
        ElMessage.error('扣除U糖失败！')
        return
      }

      // 复制组件代码
      const result = await get(`/api/widget/code/${item._id}`)
      if (result?.errno === 0) {
        ElMessage.success('组件已复制，请返回设计工具粘贴！')
        copyToClipboard(result.data.code)
      } else {
        ElMessage.error('复制失败!')
      }
    }
  } catch (error) {
    ElMessage.error('复制组件异常，请稍后重试!')
  }
}

// 重置，子组件关闭登录时调用
const resetLoginPopup = () => {
  showLoginPopup.value = false
}

// 等待所有图片加载完成的函数
const waitForImagesToLoad = () => {
  const imgElements = document.querySelectorAll('.list_item img')
  const imgPromises = [] // 存储所有图片加载的 Promise

  // 遍历每一个图片元素
  imgElements.forEach((img) => {
    const imgPromise = new Promise((resolve) => {
      // 如果图片已经加载完成，则立即解析 Promise
      if (img.complete && img.naturalHeight !== 0) {
        resolve()
      } else {
        // 如果图片没有加载完成，则监听图片的 onload 事件
        img.onload = () => resolve()
        img.onerror = () => resolve() // 处理加载错误的情况
      }
    })
    // 将该 Promise 添加到 imgPromises 数组中
    imgPromises.push(imgPromise)
  })
  return Promise.all(imgPromises)
}

// 根据浏览器宽度显示列数和调整容器宽度
const updateColumns = () => {
  const width = window.innerWidth
  if (width >= 500 && width <= 1600) {
    columns.value = 4
    containerWidth.value = '11.9rem'
  } else if (width === 1920) {
    columns.value = 6
    containerWidth.value = '18rem'
  } else if (width <= 430) {
    columns.value = 2
    containerWidth.value = '3.9rem'
  } else {
    columns.value = 5
    containerWidth.value = '14.8rem'
  }
}

// 组件瀑布流布局方法
const getWaterfall = () => {
  // 选择所有带有类名 'list_item' 的元素
  const items = document.querySelectorAll('.list_item')
  // 如果没有找到任何元素，则返回
  if (items.length === 0) return

  // 初始化或重置列高度数组，将所有值设置为0，数组的长度为列数
  array.value = new Array(columns.value).fill(4)
  // 遍历每一个元素
  items.forEach((item, index) => {
    if (index < columns.value) {
      // 如果元素的索引小于列数，表示该元素属于第一行
      item.style.top = '20px' // 设置顶部位置
      item.style.left = `${item.clientWidth * index}px` // 设置左侧位置，按列数排列
      array.value[index] = item.clientHeight // 记录当前列的高度
    } else {
      // 如果元素的索引大于等于列数，表示该元素属于后续行
      const minHeight = Math.min(...array.value) // 找到当前最小的列高度
      const minIndex = array.value.findIndex((height) => height === minHeight) // 找到最小高度的列索引
      item.style.top = `${minHeight + 25}px` // 设置顶部位置，距离最小高度列的底部
      item.style.left = `${items[minIndex].offsetLeft}px` // // 设置左侧位置，与最小高度列对齐
      array.value[minIndex] += item.clientHeight // 更新最小高度列的高度
    }
  })
}

// 图片加载完成后，重新计算布局
const handleImageLoad = () => {
  getWaterfall() // 重新计算瀑布流布局
  getWaterfallByPicture()
}

// 查询UI/UX图片
const getImageData = async (page = 1) => {
  try {
    const result = await get('/api/appui/images', { page })
    if (result?.errno === 0) {
      allAppImages.value = result.data.list || [] // 列表数据
      totalCountScreen.value = result.data.totalCount || 0
      totalPagesScreen.value = result.data.totalPages || 0 // 获取总页数
      currentPageScreen.value = page
    }
  } catch (error) {
    console.error(error)
  }
}
// 切换页码
const handleCurrentChangeScreen = (page) => {
  getImageData(page)
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 平滑滚动效果
  })
}

// 查询设计思维图
const getReadUI = async (page = 1) => {
  try {
    const result = await get('/api/appui/readui-all', { page })
    if (result?.errno === 0) {
      readUI.value = result.data.list || [] // 列表数据
      uiTotal.value = result.data.totalCount || 0
      uiTotalPages.value = result.data.totalPages // 获取总页数
      uiPage.value = result.data.currentPage // 更新当前页数
    }
  } catch (error) {
    console.error(error)
  }
}
// 切换页码
const handleChangeUI = (page) => {
  getReadUI(page)
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 平滑滚动效果
  })
}

// 显示截图弹窗
const showDetailsImage = async (
  identifier,
  title,
  coverImage,
  url,
  tags,
  detailImageId
) => {
  clickedIdentifier.value = identifier
  selectedDetailImageUrl.value = url // 更新当前图片
  selectedTitle.value = title
  selectedCoverImage.value = coverImage
  selectedTags.value = tags
  selectedAppuiId.value = detailImageId
  showAppImage.value = true // 显示弹窗
  document.body.style.overflow = 'hidden' // 禁止页面滚动
  await getWidgetByUITags(tags) // 按标签查询相似组件
}
// 关闭大图弹窗
const hideDetailsImage = async () => {
  showAppImage.value = false
  enableScroll()
  reloadCandy() // 重新加载顶部U糖数据
}

// 关闭弹窗回复滚动
const enableScroll = () => {
  document.body.style.overflow = ''
}

// 获取1条广告
// const getRandomMarketAd = async () => {
//   try {
//     const result = await get('/api/market-ad/random')
//     if (result?.errno === 0 && result?.data) {
//       // 为广告添加 isAd 标识
//       randomMarketAd.value = {
//         ...result.data,
//         isAd: true // 添加广告标识
//       }
//     }
//   } catch (error) {
//     console.error(error)
//   }
// }

// 复制口令
const copyMarketAdCode = async (code) => {
  try {
    await navigator.clipboard.writeText(code)
    ElMessage({
      showClose: true,
      message: '淘口令已复制，打开淘宝App即可自动识别！',
      type: 'success',
      duration: 5000 // 0为不自动关闭，默认值3000
    })
  } catch (error) {
    console.error('复制失败:', error)
    ElMessage.error('复制失败，请重试')
  }
}

// 跳转广告
const openAdLink = (link) => {
  window.open(link, '_blank') // 在新窗口中打开对应的链接
}

// 图库类型
const pictureType = ref([
  { type: '最新', url: '/api/aipng' },
  { type: '免费', url: '/api/aipng/free' },
  { type: '4K', url: '/api/aipng/hd' },
  { type: '背景', url: '/api/aipng/background' },
  { type: '插画', url: '/api/aipng/illustration' },
  { type: '卡通', url: '/api/aipng/cartoon' }
])

const selectedType = ref(0) // 默认选中第一项
const selectItem = (index, url) => {
  selectedType.value = index
  getPngList(url)
}

// 获取图库列表
const getPngList = async (url, page = 1) => {
  try {
    const result = await get(url, { page })
    if (result?.errno === 0) {
      pngList.value = result.data.list || result.data || []
      nextTick(() => {
        getWaterfallByPicture()
      })
      totalCountToPng.value = result.data.totalCount || 0 // 总数
      currentPageToPng.value = page // 当前页
      totalPagesToPng.value = result.data.totalPages || 0 // 获取总页数
    }
  } catch (error) {
    console.error(error)
  }
}

// 图片瀑布流布局方法
const getWaterfallByPicture = () => {
  // 选择所有带有类名 'list_item' 的元素
  const items = document.querySelectorAll('.list_item_ai')
  // 如果没有找到任何元素，则返回
  if (items.length === 0) return

  // 初始化或重置列高度数组，将所有值设置为0，数组的长度为列数
  array.value = new Array(columns.value).fill(4)
  // 遍历每一个元素
  items.forEach((item, index) => {
    if (index < columns.value) {
      // 如果元素的索引小于列数，表示该元素属于第一行
      item.style.top = '4px' // 设置顶部位置
      item.style.left = `${item.clientWidth * index}px` // 设置左侧位置，按列数排列
      array.value[index] = item.clientHeight // 记录当前列的高度
    } else {
      // 如果元素的索引大于等于列数，表示该元素属于后续行
      const minHeight = Math.min(...array.value) // 找到当前最小的列高度
      const minIndex = array.value.findIndex((height) => height === minHeight) // 找到最小高度的列索引
      item.style.top = `${minHeight + 3}px` // 设置顶部位置，距离最小高度列的底部
      item.style.left = `${items[minIndex].offsetLeft}px` // // 设置左侧位置，与最小高度列对齐
      array.value[minIndex] += item.clientHeight // 更新最小高度列的高度
    }
  })
}

// 切换页码
const handleChangeToAI = (page) => {
  getPngList(page)
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 平滑滚动效果
  })
}

// 按标签查询相似图片
const getAIPngByTags = async (id) => {
  const tags = currentAIPng.value.tags
  const response = await post('/api/aipng/search/tags', { tags, id })
  if (response?.errno === 0 && response?.data) {
    similarAIPng.value = response.data
  }
}

// 显示AI图库弹窗
const showAIPng = async (id) => {
  try {
    const result = await get(`/api/aipng/${id}`)
    if (result?.errno === 0 && result?.data) {
      currentAIPng.value = result.data // 更新当前图片数据
      showAiPng.value = true
      document.body.style.overflow = 'hidden'
      // 更新浏览器地址栏中的 URL
      // const newUrl = `/aigc/${id}`
      // window.history.pushState({}, '', newUrl)
      getAIPngByTags(id) // 按标签查询相似组件
    } else {
      document.body.style.overflow = 'auto'
      console.error('获取失败:', result?.errmsg || '未知错误')
    }
  } catch (error) {
    console.error('获取失败:', error.message)
  }
}

// 记录浏览数
const recordView = async (id) => {
  try {
    const result = await post('/api/article/view', { id })
    return result
  } catch (error) {
    console.error('', error.message)
  }
}

// 进入文章详情
const goToArticleDetails = async (itemId) => {
  await recordView(itemId) // 记录浏览数
  getArticle() // 更新数据
  // 使用路由名称进行导航，并传递参数
  const url = router.resolve({ name: 'community-details', params: { id: itemId } }).href

  // 在新标签页中打开该路由
  window.open(url, '_blank')
}

// 查询文章
const articleList = ref([]) // 文章列表
const articleListByTitle = ref([])
const getArticle = async () => {
  try {
    const result = await get('/api/article/home')
    if (result?.errno === 0) {
      const cleanedData = result.data.map((item) => ({
        ...item,
        text: DOMPurify.sanitize(item.text)
      }))
      articleList.value = cleanedData || [] // 全部数据
      console.log(articleList.value)

      // 获取当前时间的年月日
      const currentDate = moment().startOf('day') // 获取当前日期的零点时间

      // 取当前时间与addTime字段的年月日比较
      articleListByTitle.value.forEach((article) => {
        const addTimeDate = moment(article.addTime, 'YYYY-MM-DD HH:mm:ss').startOf('day') // 获取文章添加时间的年月日
        if (currentDate.isSame(addTimeDate, 'day')) {
          article.newTagByArticle = true // 设置newTagByArticle为true
        }
      })
    }
  } catch (error) {
    console.error(error)
  }
}

// 【显示今日复制】点击今日复制通知子组件
const childRef = ref(null)
const notifyShowRecordBox = () => {
  childRef.value.showRecordBox() // 调用子组件的方法
}

// 查询历史记录
const recordWidget = ref(0) // 记录组件
const getRecordWidget = async () => {
  // 验证是否登录
  const isLoggedIn = localStorage.getItem('isLogin') === 'true'
  if (!isLoggedIn) {
    return
  }
  try {
    const userId = userInfo._id
    const result = await get(`/api/candyLog/record/${userId}`)
    if (result?.errno === 0 && result?.data) {
      recordWidget.value = result.data.length
    }
  } catch (error) {
    console.error('查询记录失败:', error.message)
    throw error
  }
}

// 获取已发布的组件数量
const widgetCountByUser = ref(0)
const getWidgetByUser = async () => {
  const result = await get(`/api/widget/me/${userInfo._id}`)
  if (result?.errno === 0) {
    widgetCountByUser.value = result.data.list.length
  }
}

// 显示被复制次数
const showCopycount = () => {
  ElMessage.success('已发布组件累计被复制的次数')
}

// 获取被复制的总数
const isCopycount = ref(0)
const getCopyCountByUser = async () => {
  const result = await get(`/api/candyLog/record/user/${userInfo._id}`)
  if (result?.errno === 0) {
    isCopycount.value = result.data
  }
}

// 显示登录弹窗
const showLoginbox = () => {
  showLoginPopup.value = true
}

// 监听 widget 数据变化
watch(widget, () => {
  nextTick(() => {
    waitForImagesToLoad().then(() => {
      getWaterfall()
      loading.value = false // 图片加载完成后，隐藏 loading 图
    })
  })
})
// 监听路由变化
watch(
  () => route.path,
  (newPath) => {
    showBottomTips.value = newPath === '/'
    // 当路径为以下内容时隐藏容器
    isWidgetTab.value =
      newPath === '/my' ||
      newPath === '/thinking' ||
      newPath === '/appui' ||
      newPath === '/aigc'
    if (newPath === '/thinking') {
      getReadUI() // 执行目标函数
    }

    if (newPath === '/appui') {
      getImageData() // 执行目标函数
    }

    if (newPath === '/aigc') {
      getPngList(pictureType.value[0].url) // 执行目标函数
    }
  },
  { immediate: true } // 初始化时立即执行一次
)

watch(
  () => route.path,
  () => {
    handleScroll() // 路由变化时执行一次检查
  }
)
</script>

<style lang="scss">
@import "../style/widgeview.scss";
</style>
